export const restUser = {
  data() {
    return {
      user: {
        id_group: '-1',
        firstname: '',
        lastname: '',
        username: '',
        password: '',
        permissions: {
          users: false,
          layers: false,
          geo: false,
          maps: false,
          //permiso visor activado por defecto segun observacion SENAPRED 06/2026 ("2. Se debe dejar activado, por defecto, el ticket Visor.")
          visor: true,
          annotation: false,
          documents: false
        }
      },
      users: []
    }
  },
  methods: {
    getUser() {
      const backendurl = this.$store.getters.backendurl
      this.$http.get(`${backendurl}api/v1/users/${this.$route.params.idUser}`)
        .then((response) => {
          this.user = response.data
          this.actualUsername = response.data.username
        })
        .catch((error) => {
          console.log(error)
          this.message = error.response.data.message
        })
    },
    getUsersPages(page, search = '', sortKey = '', sortOrder = 'asc', size = 10) {
      const backendurl = this.$store.getters.backendurl
      const params = new URLSearchParams({ page, size })
      if (search) params.set('search', search)
      if (sortKey) params.set('sort', sortKey)
      params.set('order', sortOrder)

      this.$http.get(`${backendurl}api/v1/users?${params.toString()}`)
        .then((response) => {
          this.users = response.data || []
          this.totalPages = response.headers.totalpages === undefined
            ? 0
            : parseInt(response.headers.totalpages, 10)
        })
        .catch((error) => {
          console.log(error)
          this.message = error.response.data.message
        })
    },
    getUsersByGroup(page, idGroup, search = '', sortKey = '', sortOrder = 'asc', size = 10) {
      const backendurl = this.$store.getters.backendurl
      const params = new URLSearchParams({ page, size })
      if (search) params.set('search', search)
      if (sortKey) params.set('sort', sortKey)
      params.set('order', sortOrder)

      this.$http.get(`${backendurl}api/v1/groups/${idGroup}/users?${params.toString()}`)
        .then((response) => {
          this.users = response.data || []
          this.totalPages = response.headers.totalpages === undefined
            ? 0
            : parseInt(response.headers.totalpages, 10)
        })
        .catch((error) => {          // Previously missing — silent failure on group-filtered fetch
          console.log(error)
          this.message = error.response.data.message
        })
    },
    postUser() {
      const backendurl = this.$store.getters.backendurl
      this.$http.post(`${backendurl}api/v1/users`, this.user)
        .then((response) => {
          this.$router.push(`/usuarios/${response.data.id}/asignar-mapas`)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    putUser() {
      const backendurl = this.$store.getters.backendurl
      this.$http.put(`${backendurl}api/v1/users/${this.$route.params.idUser}`, this.user)
        .then(() => {
          this.$router.push(`/usuarios/${this.$route.params.idUser}`)
        })
        .catch((error) => {
          console.log(error)
          this.message = error.response.data.message
        })
    },
    deleteUser() {
      const backendurl = this.$store.getters.backendurl
      this.$http.delete(`${backendurl}api/v1/users/${this.$route.params.idUser}`)
        .then(() => {
          this.$router.push('/usuarios')
        })
        .catch((error) => {
          console.log(error)
          this.message = error.response.data.message
        })
    }
  }
}
